import { useAsync } from "react-use";
import {
    getBloodTestData_forTable,
    getPeakValues,
    getSlopesAndResponses,
    getSpirometeryData,
} from "../api/summary-tables";
import useTestId from "./useTestId";

export enum TablesTypes {
    PEAK_VALUES = "Peak Values",
    SLOPES = "Slopes & Responses",
    SPIROMETRY = "Spirometry",
    LAB_RESULTS = "Lab Results",
}

export default function useSummaryTablesData({ type }: { type: TablesTypes }) {
    const testId = useTestId();

    const { value, loading, error } = useAsync(async () => {
        if (!testId) return null;
        switch (type) {
            case TablesTypes.PEAK_VALUES: {
                return await getPeakValues({ testId });
            }
            case TablesTypes.SLOPES: {
                return await getSlopesAndResponses({ testId });
            }
            case TablesTypes.SPIROMETRY: {
                return await getSpirometeryData({ testId });
            }
            case TablesTypes.LAB_RESULTS: {
                return await getBloodTestData_forTable({ testId });
            }
        }
    }, [type]);

    return { tables: value, loading, error };
}
